export const CLEAR_STORE = 'store/CLEAR_STORE';

export const clearStore = () => {
  return {
    type: CLEAR_STORE,
  };
};
